export default __webpack_public_path__ + "static/media/crossBlack.63fe3333.svg";